import { withRouter } from 'react-router-dom';

import MobileNavHeader from './MobileNavHeader';


export default withRouter(MobileNavHeader);
